import axios from 'axios'

export default axios.create({
    baseURL:" https://first-heroku-app-test-amit.herokuapp.com/"
})